import { SvgIcon } from '@material-ui/core'

export default function PlayIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g>
                <g transform="translate(4,4)">
                    <path
                        d="M12.8441 9.01175C13.5053 8.50009 13.5053 7.50179 12.8441 6.99014C10.8457 5.44387 8.61422 4.2251 6.23319 3.37945L5.79821 3.22496C4.96603 2.9294 4.08702 3.49244 3.97436 4.35147C3.65959 6.75161 3.65959 9.25027 3.97436 11.6504C4.08702 12.5094 4.96603 13.0725 5.79821 12.7769L6.23319 12.6224C8.61422 11.7768 10.8457 10.558 12.8441 9.01175Z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </SvgIcon>
    )
}
